import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const About = () => {   
const carouselEvents = {
        autoplay: false,
        loop: true,
        margin: 10,
        nav: true,
         navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        dots: true,
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 2
            },

            1024: {
                items: 3
            },

            1366: {
                items: 3
            },

            1650: {
                items: 4
            }
        }
    };

return (
       
<>    

         <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/aboutUs.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h1>Our Story</h1>
                            {/* <h4>Travel Agents & Tour Operator</h4> */}
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>


            <section className="about section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <div className="section-title">Siddhartha International</div> */}
                            <div className="row">
                                <div className="col-lg-9 col-md-12">
                                    <p>Founded by visionary entrepreneur Mr. Manoj Saluja, <strong>Siddhartha International and Residency Group Hotels</strong>  have emerged as leading hospitality chain in India's Buddhist and Jain circuit. With a deep understanding of the region's rich cultural heritage, our hotels offer serene retreats for travelers seeking spiritual growth, cultural exploration, and memorable experiences.</p>
                                    <p>Driven by a passion for hospitality and a commitment to excellence, Siddhartha International and Residency Group Hotels to cater to the growing demand for authentic and immersive experiences in India's heartland. Our properties in Rajgir, Bodhgaya, Vaishali, and Sravasti provide a unique blend of modern comforts and spiritual significance.</p>
                                    <p>Siddhartha International Tours and Travel Company, Is a recognized and trusted name in the travel industry, approved by the Department of Tourism, Government of India. With over three decades of expertise, we offer personalized travel experiences, exploring India's rich cultural heritage and natural beauty. From spiritual pilgrimages to luxurious retreats, our expert team crafts unforgettable journeys. Discover hidden gems, iconic landmarks, and local traditions with us.</p>
                               <p></p>
                               
                               
                               <div className="content mt-30">
                                <div className="cont_about">
                                  <h3>Address</h3>
                                    <p> 802, 8th Floor, New Delhi House, 27, <br />
                                        Barakhamba Road, New Delhi - 110001<br />
                                        <strong>Mob. No.</strong> - <a href='tel:+91 92893 00353'>+91 92893 00353</a><br />
                                        <strong>Tel No.</strong> - <a href='tel:+91 11-43074778'>+91 11-43074778, 23730927</a><br />
                                        <strong>Email</strong> - <a href='mailto:siddharthai@hotmail.com'> siddharthai@hotmail.com</a></p>
                                </div>
                            </div>
                                <a href="https://www.siddharthainternational.com/" className="butn-dark2" target="_blank" rel="noopener noreferrer">
                                    View Details
                                </a>
                                </div>
                                <div className="col-lg-3 col-md-12">
                                    <img className="img-fluid Manoj-saluja" data-wow-delay="0.3s" src="img/rooms/Manoj-saluja.jpg" alt='' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
<section class="section-padding" data-scroll-index="1">
        <div class="container">
            {/* <div className="section-title">Video</div> */}
              <div class="row">
                              <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>                    
                                 <div className='item'>
                                     <a href="img/team/about-1.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-1.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-a.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-a.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-b.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-b.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-c.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-c.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-d.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-d.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>


                                 <div className='item'>
                                     <a href="img/team/about-2.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-2.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-3.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-3.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-4.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-4.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-5.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-5.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-6.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-6.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-7.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-7.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-8.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-8.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-9.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-9.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/about-10.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-10.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-11.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-11.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-12.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-12.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-13.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-13.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-14.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-14.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-15.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-15.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-16.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-16.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-17.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-17.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/about-18.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/about-18.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/bus-1.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-1.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
                                 <div className='item'>
                                     <a href="img/team/bus-2.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-2.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/bus-3.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-3.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/bus-4.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-4.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/bus-5.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-5.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                                 <div className='item'>
                                     <a href="img/team/bus-6.jpg" title="" class="img-zoom">
                                         <div class="img-block">
                                             <div class="wrapper-img"> 
                                                 <img src="img/team/bus-6.jpg" class="img-fluid mx-auto d-block" alt="work-img" />
                                                  </div>                              
                                         </div>
                                     </a>                        
                                 </div>
             
                             </OwlCarousel>
                         </div>
        </div>
    </section>

    <section className="bg-white">
      <div className="col-md-12">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14007.691430073648!2d77.21265418999756!3d28.63207404449467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd37826e6ee3%3A0x86e193c319a018e2!2sSiddhartha%20International!5e0!3m2!1sen!2sin!4v1751356259203!5m2!1sen!2sin" width="100%" height="350" frameborder="0" className="mappie" allowfullscreen title="Google Map - Siddhartha International"></iframe>

        </div>

</section>

</>
  )
};

export default About;